import React from 'react';
import BreadCrumb from './BreadCrumb';
import PowerGenPlantListing from './PowerGenPlantListing';

function PowerGenPlantPage() {
    return ( 
        <>
            <BreadCrumb />

            <PowerGenPlantListing />
            
            {/* <Herobottom /> */}
        </>
     );
}

export default PowerGenPlantPage;